import { parsePhoneNumber } from 'libphonenumber-js'
import { z } from 'zod'

import i18n from '@/config/i18n'

// Optional stricter country overrides
const countryOverrides: Record<string, RegExp> = {
  DZ: /^(?:5(?:[4-6]\d)|6(?:[569]\d|7[0-6])|7[7-9]\d|2\d{2})\d{6}$/ // Algeria
}

export const phoneSchema = z
  .string()
  .min(1, i18n.t('registration.phone.required'))
  .refine(
    value => {
      try {
        const phone = parsePhoneNumber(value)
        if (!phone?.isValid()) return false

        const override = countryOverrides[phone.country as string]
        if (override) {
          return override.test(phone.nationalNumber)
        }

        return true
      } catch {
        return false
      }
    },
    {
      message: 'Invalid phone number'
    }
  )
